module.exports = __webpack_public_path__ + "static/alisi-641db17beb86f3653457307bbfef2279.png";